<template>
  <v-content>
    <v-container fluid>
      <v-layout>
        <v-flex>
          <OLoadingDialog :value="isLoading" />

          <NewOwnerDialog ref="newOwnerDialog" />
          <EditOwnerDialog ref="editOwnerDialog" />

          <v-card>
            <v-toolbar class="card-bar">
              <v-toolbar-title>Responsáveis</v-toolbar-title>
              <v-btn icon class="ml-5" @click="reload">
                <v-icon>refresh</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn color="primary" @click="newRow()"
                >Novo responsável...</v-btn
              >
            </v-toolbar>

            <ODataTable
              :spec="spec"
              :items="rows"
              :disableInitialSort="true"
              @rowClicked="selectRow"
            />
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { VehicleOwner } from '@/models'

let color = 'grey--text text--lighten-1',
  grey = x => ({ html: `<span class="${color}">${x}</span>` })

export default {
  components: {
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    ODataTable: require('oderon-vue/cpts/ODataTable').default,
    NewOwnerDialog: require('./NewOwnerDialog').default,
    EditOwnerDialog: require('./EditOwnerDialog').default
  },
  data() {
    return {
      isLoading: false,
      rows: [],
      spec: [
        { t: 'ID|', d: 'id', f: grey, w: 90 },
        { t: 'Veículo|', d: 'vehicleId', f: grey, w: 150 },
        { t: '|Organização', d: 'vehicle.org.name', w: 200 },
        { t: '|Placa', d: 'vehicle.code' },
        { t: 'Nome', d: 'name' }
      ]
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      this.rows = await VehicleOwner.findAll()
    },

    async newRow() {
      let dialog = this.$refs.newOwnerDialog,
        res = await dialog.open()

      if (res != null) {
        console.log(res)
        await this.$loading(async () => {
          await VehicleOwner.save(res)
          await this.fetchData()
        })
        this.$snack('Salvo com sucesso')
      }
    },

    async selectRow(r) {
      let res = await this.$refs.editOwnerDialog.open(r.id)

      if (res == 'DELETE') {
        this.confirmDelete(r)
        return
      } else if (res != null) {
        await this.$loading(async () => {
          await VehicleOwner.save(res)
          await this.fetchData()
        })
        this.$snack('Salvo com sucesso')
      }
    },

    async confirmDelete(r) {
      let result = await this.$root.$confirm({
        title: `Deseja remover o responsável "${r.name}"?`,
        okText: 'Sim, remover',
        cancelText: 'Não, Cancelar'
      })

      if (result) {
        this.$loading(async () => {
          await VehicleOwner.delete(r.id)
          await this.fetchData()
          this.$snack('Removido com sucesso')
        })
      }
    }
  }
}
</script>

<style></style>
